export enum InvoiceItemColumnType {
  INVOICE_ID = 'INVOICE_ID',
  ITEM = 'ITEM',
  LINE_ITEM_ID = 'LINE_ITEM_ID',
  OTHER = 'OTHER',
  PRICE = 'PRICE',
  PRODUCT_CODE = 'PRODUCT_CODE',
  QUANTITY = 'QUANTITY',
  UNIT_PRICE = 'UNIT_PRICE',
}

export interface InvoiceItemColumnInfo {
  field: string;
  headerName: string;
  type: InvoiceItemColumnType;
}
